import React, { useState } from 'react'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'
import './index.css'

const filterOptions = {
  'IDEAL FOR': ['Men', 'Women', 'Baby and Kids'],
  OCCASION: ['Casual', 'Formal', 'Sportswear', 'Party'],
  WORK: ['Office', 'Outdoor', 'Gym'],
  'RAW MATERIALS': ['Cotton', 'Polyester', 'Wool', 'Silk'],
  PATTERN: ['Solid', 'Striped', 'Printed', 'Checked'],
}

const SidePanel = () => {
  const [openDropdown, setOpenDropdown] = useState(null)

  const toggleDropdown = section => {
    setOpenDropdown(openDropdown === section ? null : section)
  }

  return (
    <div className="sidepanel-container">
      {/* Customization */}
      <div className="custom-section">
        <label className="checkbox-label">
          <input type="checkbox" />
          Customize
        </label>
      </div>
      <hr />

      {/* Dynamic Filter Sections */}
      {Object.entries(filterOptions).map(([title, options]) => (
        <div key={title} className="filter-section">
          <div
            className="section-header"
            onClick={() => toggleDropdown(title)}
          >
            <h2>{title}</h2>
            {openDropdown === title ? (
              <FaChevronUp  />
            ) : (
              <FaChevronDown  />
            )}
          </div>

          <p className="default-option">All</p>

          {openDropdown === title && (
            <ul className="dropdown-list">
              {options.map((opt, i) => (
                <li key={i}>
                  <label className="checkbox-label">
                    <input type="checkbox" />
                    {opt}
                  </label>
                </li>
              ))}
            </ul>
          )}
          <hr />
        </div>
      ))}
    </div>
  )
}

export default SidePanel








